// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/receivables/recurring-invoices',
        component: () =>
            import('@/pages/[organisation]/receivables/recurring-invoices.vue'),
        name: 'accounts-receivable.recurring-invoices.search-recurring-invoices',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.recurring-invoice.view-recurring-invoices',
        },

        children: [
            {
                path: 'create-recurring-invoice',
                component: () =>
                    import('@/pages/[organisation]/receivables/recurring-invoices/create-recurring-invoice.vue'),
                name: 'accounts-receivable.recurring-invoices.create-recurring-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.recurring-invoice.create-recurring-invoice',
                },
            },
            {
                path: ':id/update-recurring-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.recurring-invoices" */ '@/pages/[organisation]/receivables/recurring-invoices/recurring-invoice/[id]/edit.vue'),
                name: 'accounts-receivable.recurring-invoices.update-recurring-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.recurring-invoice.update-recurring-invoice',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.recurring-invoices" */ '@/pages/[organisation]/receivables/recurring-invoices/recurring-invoice/[id].vue'),
                name: 'accounts-receivable.recurring-invoices.view-recurring-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.recurring-invoice.view-recurring-invoices',
                },
            },
        ],
    },
];
